import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductosSubDestinosMontos} from '../_models/producto-subdestino-monto';

@Injectable({
  providedIn: 'root'
})
export class ProductoSubdestinoMontoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinosMontos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosSubDestinosMontos[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductosSubDestinosMontos[] ) );
  }

  listadoPorDestino( idProductoDestino: string ) {
    return this.httClient.get( this.rutServicio + '/productoDestinoMonto/' + idProductoDestino ).pipe( map( res => res as ProductosSubDestinosMontos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosSubDestinosMontos ) );
  }

  crear( regCrear: ProductosSubDestinosMontos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosSubDestinosMontos ) );
  }

  actualizar( regActualizar: ProductosSubDestinosMontos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductosSubDestinosMontos[] ) {
    regActualizar.map( ( s: ProductosSubDestinosMontos ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductosSubDestinosMontos[] ) );
  }

  listadoPorDestinoProducto( idProducto: string , idDestinoProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/destinoProducto/' + idDestinoProducto + '/enabled'  ).pipe( map( res => res as ProductosSubDestinosMontos[] ) );
  }
}
